import React, { useState } from "react";
import {
  Dimensions,
  FlatList,
  Image,
  Modal,
  SafeAreaView,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  TouchableWithoutFeedback,
  View,
  Pressable,
  Linking,
} from "react-native";
import { ModalDel, OfflinVehicle, VehicleList } from "../../../Constants/Data";
import AppColors from "../../../Constants/AppColors";
import AppFonts from "../../../Constants/AppFonts";
import AppImages from "../../../Constants/AppImages";
import { useTranslation } from "react-i18next";
// import Clipboard from "@react-native-community/clipboard";
import Appstyles from "../../../Constants/AppStyles";
const { width, height } = Dimensions.get("window");
const Offline = ({ navigation }) => {
  const [DotModal, setDotModal] = useState(false);
  const [Modalvisible1, setModalvisible1] = useState(false);
  const [select, setSelected] = useState(0);

  const handlePress = () => {
    setSelected(!select);
  };
  const t = (key, options = {}) => {
    // If key is an object with translation path (like "common:translation.Search Vehicle....")
    if (typeof key === "object" && key["common:translation"]) {
      return key["common:translation"];
    }

    // If key is a string, extract the text after the last colon
    if (typeof key === "string") {
      const parts = key.split(":");
      return parts[parts.length - 1].replace(/^translation./, "");
    }

    return key;
  };
  const [selectedButton, setSelectedButton] = useState(1);

  const handleBoxPressbtn = (item) => {
    setSelectedButton(item);
  };

  const [DotModalshare, setDotModalshare] = useState(false);

  const [activeIndex, setActiveIndex] = useState(0);

  const handleTextPress = (index) => {
    setActiveIndex(index);
  };

  const [linkText, setLinkText] = useState(
    "https://Vehicletrackingsystem.com/12345"
  );
  const [isCopied, setIsCopied] = useState(false);

  // const copyLink = async () => {
  //   try {
  //     await Clipboard.setString(linkText);
  //     setIsCopied(true);
  //     Alert.alert("Link Copied", "The link has been copied to the clipboard.");
  //   } catch (error) {
  //     console.error("Failed to copy link:", error);
  //     Alert.alert("Copy Failed", "An error occurred while copying the link.");
  //   }
  // };
  const shareEmail = () => {
    const emailUrl = `mailto:?subject=${encodeURIComponent(
      "Check out this link"
    )}&body=${encodeURIComponent(linkText)}`;
    Linking.openURL(emailUrl)
      .then(() => {
        console.log("Email app opened");
      })
      .catch((error) => {
        console.error("Failed to open email app:", error);
      });
  };

  const shareWhatsApp = () => {
    const whatsappUrl = `whatsapp://send?text=${encodeURIComponent(linkText)}`;
    Linking.openURL(whatsappUrl)
      .then(() => {
        console.log("WhatsApp app opened");
      })
      .catch((error) => {
        console.error("Failed to open WhatsApp app:", error);
      });
  };

  const shareSMS = () => {
    const smsUrl = `sms:?body=${encodeURIComponent(linkText)}`;
    Linking.openURL(smsUrl)
      .then(() => {
        console.log("SMS app opened");
      })
      .catch((error) => {
        console.error("Failed to open SMS app:", error);
      });
  };

  //----------search -------del

  const OfflinVehicle = [
    {
      id: 1,
      img: AppImages.ShadowCar,
      Dot: AppImages.Threedots,
      T1: "Vehicle Name",
      T2: "Utility CAB",

      H1: "MH-12-5022",
      H2: "IMEI No.",
      H3: "1234567894561230",
      H4: "Transportation Type",
      H5: "Passenger",
      H6: "Driver Name",
      H7: "Mr. John Doe",
      H8: "Vehicle Type",
      H9: "Car",
      H10: "Vehicle Capacity/Passenger",
      H11: "60",
    },
    {
      id: 2,
      img: AppImages.ShadowBike,
      Dot: AppImages.Threedots,
      T1: "Vehicle Name",
      T2: "Utility CAB",

      H1: "MH-12-5022",
      H2: "IMEI No.",
      H3: "1234567894561230",
      H4: "Transportation Type",
      H5: "Passenger",
      H6: "Driver Name",
      H7: "Mr. John Doe",
      H8: "Vehicle Type",
      H9: "Car",
      H10: "Vehicle Capacity/Passenger",
      H11: "60",
    },
    {
      id: 3,
      img: AppImages.ShadowCar,
      Dot: AppImages.Threedots,
      T1: "Vehicle Name",
      T2: "Utility CAB",

      H1: "MH-12-5022",
      H2: "IMEI No.",
      H3: "1234567894561230",
      H4: "Transportation Type",
      H5: "Passenger",
      H6: "Driver Name",
      H7: "Mr. John Doe",
      H8: "Vehicle Type",
      H9: "Car",
      H10: "Vehicle Capacity/Passenger",
      H11: "60",
    },
    {
      id: 4,
      img: AppImages.ShadowBike,
      Dot: AppImages.Threedots,
      T1: "Vehicle Name",
      T2: "Utility CAB",

      H1: "MH-12-5022",
      H2: "IMEI No.",
      H3: "1234567894561230",
      H4: "Transportation Type",
      H5: "Passenger",
      H6: "Driver Name",
      H7: "Mr. John Doe",
      H8: "Vehicle Type",
      H9: "Car",
      H10: "Vehicle Capacity/Passenger",
      H11: "60",
    },
    {
      id: 5,
      img: AppImages.ShadowCar,
      Dot: AppImages.Threedots,
      T1: "Vehicle Name",
      T2: "Utility CAB",

      H1: "MH-12-5022",
      H2: "IMEI No.",
      H3: "1234567894561230",
      H4: "Transportation Type",
      H5: "Passenger",
      H6: "Driver Name",
      H7: "Mr. John Doe",
      H8: "Vehicle Type",
      H9: "Car",
      H10: "Vehicle Capacity/Passenger",
      H11: "60",
    },
  ];
  const [selectedItem, setSelectedItem] = useState(null);
  const [data, setData] = useState(OfflinVehicle);
  const [searchText, setSearchText] = useState(""); // State for search input

  const handleSearch = (text) => {
    setSearchText(text);
    // Implement search logic here to filter the data based on the entered text
    const filteredData = OfflinVehicle.filter((item) =>
      item.T2.toLowerCase().includes(text.toLowerCase())
    );
    setData(filteredData);
  };
  //-------Del FlatList ---------//
  const handleThreeDotPress = (item) => {
    setSelectedItem(item);
    setDotModal(true);
  };
  const handleDeleteConfirmation = () => {
    setDotModal(false);
    setModalvisible1(true);
  };
  const handleDelete = () => {
    const updatedData = data.filter((item) => item.id !== selectedItem.id);
    setData(updatedData);
    setModalvisible1(false);
    setSelectedItem(null);
  };

  return (
    <SafeAreaView style={Appstyles.safe7}>
      <View style={Appstyles.SecMainAddveh7}>
        <View>
          <View style={Appstyles.Allvehicke7}>
            <View style={Appstyles.Searchvi6}>
              <TextInput
                style={Appstyles.TextInput7}
                placeholder={t("common:translation.Search Vehicle....")}
                placeholderTextColor={AppColors.grey1}
                editable={true}
                value={searchText} // Bind search input value to state
                onChangeText={handleSearch}
              />

              <View style={Appstyles.SearchImageView}>
                <Image
                  source={AppImages.search}
                  style={Appstyles.SearchImage}
                />
              </View>
            </View>

            <Image
              source={AppImages.Import}
              style={styles.ims}
              resizeMode="contain"
            />
            <TouchableOpacity onPress={() => setDotModalshare(true)}>
              <Image
                source={AppImages.Shareit}
                style={styles.ha}
                resizeMode="contain"
              />
            </TouchableOpacity>
          </View>
        </View>
        <FlatList
          showsVerticalScrollIndicator={false}
          ListFooterComponent={() => <View style={{ padding: 45 }} />}
          data={data}
          renderItem={({ item }) => (
            <View style={{}}>
              <View style={styles.Flatmain}>
                <View style={styles.FlatmainSec}>
                  <View style={styles.FlatImg}>
                    <View style={{ flexDirection: "row" }}>
                      <Image
                        source={item.img}
                        style={{ width: 35, height: 66 }}
                        resizeMode="contain"
                      />
                      <View style={styles.FlatTxt}>
                        <Text style={styles.FlatTxtSec}>
                          {t("common:translation.Vehicle Name")}
                        </Text>
                        <Text style={styles.CopyTextSe}>{item.T2}</Text>
                      </View>
                    </View>
                    <TouchableOpacity onPress={() => handleThreeDotPress(item)}>
                      <Image
                        source={item.Dot}
                        style={styles.iamge}
                        resizeMode="contain"
                      />
                    </TouchableOpacity>
                  </View>
                </View>
                <View
                  style={{
                    borderWidth: 0.5,
                    borderColor: AppColors.grey,
                    opacity: 0.2,
                  }}
                ></View>

                <View style={{ marginHorizontal: 20, marginBottom: 15 }}>
                  <View style={{}}>
                    <View style={styles.Row}>
                      <Text style={styles.Textt}>
                        {t("common:translation.Vehicle Number")}
                      </Text>
                      <Text style={styles.TextTwo}>
                        {t("common:translation.Driver Name")}
                      </Text>
                    </View>
                    <View style={styles.Row}>
                      <Text style={styles.CopyTextSec}>{item.H1}</Text>
                      <Text style={styles.CopyText}>{item.H7}</Text>
                    </View>
                    <View style={styles.Row}>
                      <Text style={styles.Textt}>
                        {t("common:translation.IMEI No")}
                      </Text>
                      <Text style={styles.TextTwo}>
                        {t("common:translation.Vehicle Type")}
                      </Text>
                    </View>

                    <View style={styles.Row1}>
                      <Text style={styles.CopyTextSec1}>{item.H3}</Text>
                      <Text style={styles.CopyText1}>{item.H9}</Text>
                    </View>
                    <View style={styles.Row}>
                      <Text style={styles.Textt}>
                        {t("common:translation.Transportation Type")}
                      </Text>
                      <Text style={styles.NonCopy}>
                        {t("common:translation.Vehicle Capacity/Passenger")}
                      </Text>
                    </View>
                    <View style={styles.Row}>
                      <Text style={styles.CopyTextSec}>{item.H5}</Text>
                      <Text style={styles.CopyTextSec}>{item.H11}</Text>
                    </View>
                  </View>
                </View>
              </View>
            </View>
          )}
        />
      </View>
      <Modal
        animationType="slide"
        visible={DotModal}
        onRequestClose={() => {
          setDotModal(false);
        }}
        transparent={true}
      >
        <Pressable onPress={() => setDotModal(false)} style={styles.feed}>
          <View style={styles.viww}>
            <TouchableOpacity style={styles.hsh}>
              <Image source={AppImages.LineBar} style={styles.jns} />
            </TouchableOpacity>
            <View style={{ marginTop: 20 }}>
              <TouchableOpacity
                style={{}}
                onPress={() => [
                  setDotModal(false),
                  navigation.navigate("VehicleDevice"),
                ]}
              >
                <Text style={styles.ttxt}>View</Text>
              </TouchableOpacity>
              <TouchableOpacity
                style={{ marginTop: 5 }}
                onPress={() => [
                  setDotModal(false),
                  ,
                  navigation.navigate("AddVehicle"),
                ]}
              >
                <Text style={styles.ttxt}>Edit</Text>
              </TouchableOpacity>
              <TouchableOpacity
                style={{ marginTop: 5 }}
                onPress={handleDeleteConfirmation}
              >
                <Text style={styles.modo}>Delete</Text>
              </TouchableOpacity>
            </View>
          </View>
        </Pressable>
      </Modal>

      {/* //-----------DeleteModal------// */}

      <Modal
        animationType="slide"
        transparent={true}
        visible={Modalvisible1}
        onRequestClose={() => {
          setModalvisible1(!Modalvisible1);
        }}
      >
        <Pressable
          onPress={() => setModalvisible1(false)}
          style={styles.presse}
        >
          <View style={styles.dsdd}>
            <View style={styles.sss}>
              <View style={styles.fd}>
                <View style={{}}>
                  <Text style={styles.hbh}>
                    {t("common:translation.Delete Vehicle")}
                  </Text>
                </View>
              </View>
              <TouchableOpacity
                onPress={() => {
                  setModalvisible1(false);
                }}
              >
                <Image
                  source={AppImages.cross}
                  style={styles.hhsj}
                  resizeMode="contain"
                />
              </TouchableOpacity>
            </View>
            <View style={{}}></View>
            <View style={styles.lins}></View>
            <View style={styles.fasfd}>
              <Text style={styles.sdsds}>
                {t(
                  "common:translation. Are you sure you want to delete this Vehicle ?"
                )}
              </Text>
              <View style={styles.lins7}></View>
            </View>

            <View style={styles.mmm}>
              <View style={styles.hox}>
                {ModalDel.map((item, index) => (
                  <View
                    onPress={() => handleBoxPressbtn(item)}
                    style={styles.presss}
                  >
                    {selectedButton === index ? (
                      <TouchableOpacity onPress={handleDelete}>
                        <View style={{}}>
                          <View
                            style={[
                              styles.LoginWithOtpVw,
                              {
                                backgroundColor:
                                  selectedButton === index
                                    ? AppColors.brown
                                    : AppColors.C4900C,
                              },
                            ]}
                          >
                            <Text
                              style={[
                                styles.RegisterTxt,
                                {
                                  color:
                                    selectedButton === index
                                      ? AppColors.white
                                      : AppColors.C4900CC,
                                },
                              ]}
                            >
                              {item.label}
                            </Text>
                          </View>
                        </View>
                      </TouchableOpacity>
                    ) : (
                      <TouchableOpacity
                        onPress={() => [
                          // handleBoxPressbtn(item),
                          setModalvisible1(false),
                        ]}
                      >
                        <View style={{}}>
                          <View style={{}}>
                            <View
                              style={[
                                styles.LoginWithOtpVw,
                                {
                                  backgroundColor:
                                    selectedButton === index
                                      ? AppColors.brown
                                      : AppColors.C4900C,
                                },
                              ]}
                            >
                              <Text
                                style={[
                                  styles.RegisterTxt,
                                  {
                                    color:
                                      selectedButton === index
                                        ? AppColors.white
                                        : AppColors.C4900CC,
                                  },
                                ]}
                              >
                                {item.label}
                              </Text>
                            </View>
                          </View>
                        </View>
                      </TouchableOpacity>
                    )}
                  </View>
                ))}
              </View>
            </View>
          </View>
        </Pressable>
      </Modal>
      {/*  //----------------Share */}
      <Modal
        animationType="slide"
        visible={DotModalshare}
        onRequestClose={() => {
          setDotModalshare(false);
        }}
        transparent={true}
      >
        <TouchableWithoutFeedback onPress={() => setDotModalshare(false)}>
          <View
            style={{ backgroundColor: AppColors.ModalColor, flex: 1 }}
          ></View>
        </TouchableWithoutFeedback>
        <View
          style={{
            width: "100%",
            backgroundColor: "white",

            borderTopRightRadius: 16,
            borderTopLeftRadius: 16,
            position: "absolute",
            bottom: 0,
            paddingVrtical: 20,
          }}
        >
          <TouchableOpacity
            style={{ justifyContent: "center", alignItems: "center" }}
          >
            <Image
              source={AppImages.LineBar}
              style={{ width: 40, height: 2.5, marginTop: 20 }}
            />
          </TouchableOpacity>
          <View
            style={{ borderBottomWidth: 1, borderBottomColor: "#9C49001A" }}
          >
            <Text
              style={[
                styles.activeText,
                {
                  marginTop: 20,
                  marginBottom: 10,
                  fontFamily: AppFonts.OverpassBold,
                  fontSize: 18,
                  color: AppColors.brown,
                },
              ]}
            >
              {t("common:translation.Share Vehicle Details")}
            </Text>
          </View>
          <TouchableWithoutFeedback onPress={() => handleTextPress(0)}>
            <View
              style={
                {
                  //  alignItems: "center",
                  //  justifyContent: "center",
                  //  marginLeft: 10,
                  //   flexDirection:"row"
                }
              }
            >
              <Text
                style={[styles.text, activeIndex === 0 && styles.activeText]}
              >
                {t("common:translation.Link to share")}
              </Text>
            </View>
          </TouchableWithoutFeedback>
          <TouchableWithoutFeedback>
            <TouchableOpacity
              onPress={() => setDotModalshare(false)}
              style={{
                backgroundColor: AppColors.sandal,
                height: 40,
                // alignItems:"center",
                justifyContent: "center",
                marginHorizontal: 20,
                paddingHorizontal: 10,
                borderRadius: 10,
                marginVertical: 12,
              }}
            >
              <Text
                style={[
                  {
                    fontFamily: AppFonts.OverpassMedium,
                    fontSize: 14,
                    color: AppColors.brown1,
                  },
                ]}
              >
                {linkText}
              </Text>
            </TouchableOpacity>
          </TouchableWithoutFeedback>
          <View
            style={{
              backgroundColor: AppColors.brown,
              height: 40,
              alignItems: "center",
              justifyContent: "center",
              marginHorizontal: 20,
              paddingHorizontal: 10,
              borderRadius: 10,
              // marginVertical: 10,
              flexDirection: "row",
              alignSelf: "flex-end",
            }}
          >
            <Image
              source={AppImages.CopyLink}
              style={{ width: 24, height: 24, resizeMode: "contain" }}
            />
            <TouchableOpacity
            // onPress={() => [
            //   Clipboard.setString(
            //     '"https://Vehicletrackingsystem.com/12345"'
            //   ),
            //   setDotModalshare(false),
            // ]}
            >
              <Text
                style={[
                  {
                    fontFamily: AppFonts.OverpassMedium,
                    fontSize: 14,
                    color: AppColors.white,
                    marginLeft: 12,
                  },
                ]}
              >
                {isCopied ? "Link Copied!" : "Copy Link"}
                {/* {t("common:translation.Copy Link")} */}
              </Text>
            </TouchableOpacity>
          </View>

          <TouchableWithoutFeedback>
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                marginVertical: 10,
                marginHorizontal: 20,
              }}
            >
              <View
                style={{
                  flex: 1,
                  height: 1,
                  backgroundColor: AppColors.sandal,
                }}
              />
              <Text
                style={{
                  marginHorizontal: 10,

                  fontSize: 10,
                  fontFamily: AppFonts.OverpassRegular,
                  color: AppColors.dualbrown,
                }}
              >
                OR
              </Text>
              <View
                style={{
                  flex: 1,
                  height: 1,
                  backgroundColor: AppColors.sandal,
                }}
              />
            </View>
          </TouchableWithoutFeedback>
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              marginBottom: 20,
              marginHorizontal: 20,
              justifyContent: "space-between",
            }}
          >
            <TouchableOpacity
              onPress={shareEmail}
              style={{
                backgroundColor: AppColors.white,
                height: 40,
                alignItems: "center",
                justifyContent: "center",
                // marginHorizontal: 20,
                paddingHorizontal: 10,
                borderRadius: 5,
                // marginVertical: 10,
                flexDirection: "row",
                borderColor: "#9C49001A",
                borderWidth: 1,
                elevation: 5,
                shadowColor: AppColors.brown,
                // width: "28%",
                width: height * 0.16,
              }}
            >
              <Image
                source={AppImages.EmailShare}
                style={{ width: 18, height: 18, resizeMode: "contain" }}
              />
              <Text
                style={[
                  {
                    fontFamily: AppFonts.OverpassMedium,
                    fontSize: 14,
                    color: AppColors.dualbrown,
                    marginLeft: 12,
                  },
                ]}
              >
                {t("common:translation.Email")}
              </Text>
            </TouchableOpacity>
            <TouchableOpacity
              onPress={shareSMS}
              style={{
                backgroundColor: AppColors.white,
                height: 40,
                alignItems: "center",
                justifyContent: "center",
                // marginHorizontal: 20,
                paddingHorizontal: 10,
                borderRadius: 5,
                // marginVertical: 10,
                flexDirection: "row",
                borderColor: "#9C49001A",
                borderWidth: 1,
                //  width: "25%",
                elevation: 5,
                shadowColor: AppColors.brown,
                width: height * 0.16,
              }}
            >
              <Image
                source={AppImages.SmsShare}
                style={{ width: 18, height: 18, resizeMode: "contain" }}
              />
              <Text
                style={[
                  {
                    fontFamily: AppFonts.OverpassMedium,
                    fontSize: 14,
                    color: AppColors.dualbrown,
                    marginLeft: 12,
                  },
                ]}
              >
                {t("common:translation.SMS")}
              </Text>
            </TouchableOpacity>
            <TouchableOpacity
              onPress={shareWhatsApp}
              style={{
                backgroundColor: AppColors.white,
                height: 40,
                alignItems: "center",
                justifyContent: "center",
                // marginHorizontal: 20,
                paddingHorizontal: 10,
                borderRadius: 5,
                // marginVertical: 10,
                flexDirection: "row",
                borderColor: "#9C49001A",
                borderWidth: 1,
                elevation: 5,
                shadowColor: AppColors.brown,
                //  width: "25%",
                width: height * 0.16,
              }}
            >
              <Image
                source={AppImages.WhatsappShare}
                style={{ width: 18, height: 18, resizeMode: "contain" }}
              />
              <Text
                style={[
                  {
                    fontFamily: AppFonts.OverpassMedium,
                    fontSize: 14,
                    color: AppColors.dualbrown,
                    marginLeft: 12,
                  },
                ]}
              >
                {t("common:translation.WhatsApp")}
              </Text>
            </TouchableOpacity>
          </View>
        </View>
      </Modal>
    </SafeAreaView>
  );
};

export default Offline;
const styles = StyleSheet.create({
  text: {
    fontFamily: AppFonts.OverpassMedium,

    fontSize: 14,
    color: AppColors.dualbrown,
    marginTop: 10,
    marginLeft: 20,
  },
  activeText: {
    fontFamily: AppFonts.OverpassMedium,
    marginTop: 10,
    fontSize: 14,
    color: AppColors.brown1,
    marginLeft: 20,
  },
  MainView: { backgroundColor: AppColors.white, flex: 1 },
  SecMain: { marginHorizontal: 20, backgroundColor: AppColors.white },
  TExtinputView: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",

    marginTop: 25,
    width: "100%",
    paddingVertical: 10,
    // height: height * 0.04,
  },
  TExtinput: {
    fontSize: 12,
    alignItems: "center",
    fontFamily: AppFonts.OverpassMedium,
    width: "80%",
    borderRadius: 10,
    borderColor: AppColors.sandal,
    // height: height * 0.05,
    borderWidth: 1,
    paddingLeft: 20,
    flexDirection: "row",

    borderRadius: 8,
    justifyContent: "space-between",

    shadowColor: "#000001A",
    shadowOffset: { width: 1, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 1,
    // elevation: 6,
  },
  ExImport: { flexDirection: "row" },
  Flatmain: {
    marginBottom: 20,
    backgroundColor: "#F6EFE9",
    borderRadius: 10,
  },
  FlatmainSec: {
    marginTop: 5,
    // margin: 10,
    marginLeft: 10,
    paddingVertical: 10,
    paddingHorizontal: 10,
  },
  FlatImg: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  FlatTxt: { justifyContent: "center", marginLeft: 20 },
  FlatTxtSec: {
    // marginTop: 5,
    fontSize: 12,

    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.dualbrown,
  },
  FlatTxtT2: {
    fontSize: 14,
    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.brown1,
  },

  CopyText: {
    fontSize: 14,
    marginTop: 2,

    fontFamily: AppFonts.OverpassBold,
    color: AppColors.brown1,
  },
  CopyText1: {
    fontSize: 14,
    marginTop: 2,

    alignItems: "center",
    fontFamily: AppFonts.OverpassBold,
    color: AppColors.brown1,
  },
  CopyTextSec: {
    width: "50%",
    fontSize: 14,
    marginTop: 2,
    fontFamily: AppFonts.OverpassBold,
    color: AppColors.brown1,
  },
  CopyTextSec1: {
    width: "50%",
    fontSize: 14,
    marginTop: 2,
    fontFamily: AppFonts.OverpassBold,
    color: AppColors.brown1,
    alignItems: "center",
  },
  CopyTextSe: {
    fontSize: 14,
    marginTop: 5,
    fontFamily: AppFonts.OverpassBold,
    color: AppColors.brown1,
  },
  NonCopy: {
    width: width * 0.48,
    fontSize: 12,
    marginTop: 10,
    fontFamily: AppFonts.OverpassMedium,
    color: AppColors.dualbrown,
  },
  Row: { flexDirection: "row", alignItems: "center" },
  Row1: {
    flexDirection: "row",
    alignItems: "center",
  },

  Textt: {
    width: "50%",
    marginTop: 10,
    fontSize: 12,

    fontFamily: AppFonts.OverpassMedium,
    color: AppColors.dualbrown,
  },

  TextTwo: {
    fontSize: 12,
    marginTop: 10,
    fontFamily: AppFonts.OverpassMedium,
    color: AppColors.dualbrown,
  },
  //--------modal Del
  hox: {
    flexDirection: "row",
    justifyContent: "flex-end",
    marginVertical: 20,
  },
  presss: {
    width: "40%",
    marginHorizontal: 10,
  },
  //-------cancel  btn---//
  sty: {
    flexDirection: "row",
    marginVertical: 10,
  },
  LoginWithOtpVw: {
    borderColor: "#9C4900",
    borderWidth: 1,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 10,
    height: 35,
    width: "100%",
  },
  RegisterTxt: {
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 14,
    letterSpacing: 0.56,
  },
  RegisterNxt: {
    // color: AppColors.white,
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 14,
    letterSpacing: 0.56,
  },
  LoginWithOtpV: {
    borderColor: "#9C4900",
    borderWidth: 1,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 10,
    width: "100%",
    height: 40,
  },
  lins: {
    borderWidth: 0.5,
    borderColor: AppColors.grey,
    opacity: 0.2,
    marginTop: 10,
    marginHorizontal: 20,
  },
  lins7: {
    borderWidth: 0.5,
    borderColor: AppColors.grey,
    opacity: 0.2,
    marginTop: 20,
    marginBottom: 5,
  },
  vee: {
    alignItems: "flex-end",
    justifyContent: "center",
    flex: 1,
  },
  im: { width: 20, height: 20, marginRight: 30 },
  too: { alignSelf: "flex-end", justifyContent: "center" },
  ims: { width: 22, height: 22 },
  ha: { width: 22, height: 22 },
  iamge: { width: 22, height: 22, alignItems: "center" },
  feed: { backgroundColor: AppColors.ModalColor, flex: 1 },
  viww: {
    width: "100%",
    backgroundColor: "white",

    borderTopRightRadius: 16,
    borderTopLeftRadius: 16,
    position: "absolute",
    bottom: 0,
    padding: 20,
  },
  hsh: { justifyContent: "center", alignItems: "center", marginTop: 3 },
  jns: { width: "15%", height: 3 },
  yooo: {
    alignItems: "center",
    justifyContent: "center",
    marginLeft: 10,
  },
  yooo1: {
    alignItems: "center",
    justifyContent: "center",
    marginLeft: 10,
    marginTop: 2,
  },
  ttxt: {
    fontFamily: AppFonts.OverpassRegular,

    fontSize: 16,
    color: AppColors.dualbrown,
  },
  fffsf: {
    // marginTop: 5,
    flexDirection: "row",
  },
  modo: {
    fontFamily: AppFonts.OverpassRegular,

    fontSize: 16,
    color: AppColors.brown1,
  },
  presse: {
    flex: 1,
    backgroundColor: "rgba(66, 31, 0, 0.5)",

    alignItems: "center",
    justifyContent: "center",
  },
  dsdd: {
    backgroundColor: "white",
    borderRadius: 20,
    marginHorizontal: 20,
    //width: "80%",
    paddingTop: 15,
  },
  sss: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginHorizontal: 20,
    alignItems: "center",
  },
  fd: { flexDirection: "row", alignItems: "center" },
  hbh: {
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 20,
    lineheight: 25.32,
    color: AppColors.brown1,
  },
  hhsj: { width: 12, height: 12 },
  fasfd: { marginTop: 20, marginHorizontal: 20 },
  sdsds: {
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 14,
    lineheight: 17.72,
    color: AppColors.brown1,
  },
  mmm: {
    flexDirection: "row",
    alignSelf: "flex-end",

    marginHorizontal: 10,
  },
  toda: { marginTop: 20, flexDirection: "row" },
});
